export const AdminInterytdPermissions = {
  AdminInterytdPermissions: {
    permissionsId: "d481fbfe-43c1-4e98-f94e-08dc0f48c1d2",
    permissionsName: "International Sales+",
    description: null,
    componentsId: null,
    components: null
  },
};
